export const TableStyleSettings = {
  rows: {
    style: {
      minHeight: '36px', // override the row height
      '&:hover': {
        backgroundColor: '#f0f8ff', // light blue
      },
    },
  },
  headCells: {
    style: {
      paddingLeft: '4px', // override the cell padding for head cells
      paddingRight: '4px',
    },
  },
  cells: {
    style: {
      paddingLeft: '4px', // override the cell padding for data cells
      paddingRight: '4px',
      paddingTop: '4px',
      paddingBottom: '4px',
    },
  },
};

export const TableThemeSettings = {
  text: {
    primary: '#555C7C',
    secondary: '#E0E1EA',
  },
  background: {
    default: '#FFF',
  },
  context: {
    text: '#B3B4BC',
    background: '#CB4B16',
  },
  divider: {
    default: '#F0F2F9',
  },
};
